import { render, staticRenderFns } from "./AllDealersTable.vue?vue&type=template&id=289de56a&scoped=true&"
import script from "./AllDealersTable.vue?vue&type=script&lang=js&"
export * from "./AllDealersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289de56a",
  null
  
)

export default component.exports